"use strict";

class PaymentApplicationController {

    constructor($scope, $window, $filter, SSUserService, SSAppService, SSHttpService, SSUtilService, SSEoiService, SSDateService, SSAlertService,  OTPService, SSConfirmationService, $timeout, SSConfigService, NgTableParams, SSAnalyticsService, SSSaleRemarksService, SSLmsDmsUtilService, SSSaleChangeFeedService) {
        const self = this;

        self.$scope = $scope;
        self.$window = $window;
        self.$filter = $filter;

        self.SSUserService = SSUserService;
        self.SSAppService = SSAppService;
        self.OTPService = OTPService;
        self.SSConfirmationService = SSConfirmationService;
        self.NgTableParams = NgTableParams;
        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSEoiService = SSEoiService;
        self.SSDateService = SSDateService;
        self.SSAlertService = SSAlertService;
        self.SSLmsDmsUtilService = SSLmsDmsUtilService;
        self.$timeout = $timeout;
        self.SSConfigService = SSConfigService;
        self.SSAnalyticsService = SSAnalyticsService;
        self.SSSaleRemarksService = SSSaleRemarksService;
        self.SSSaleChangeFeedService = SSSaleChangeFeedService;

        self.data = SHOWSUITE.data;
        self.parameters=self.data.url_param;

        self.PROPERTY_STATUS_ARCHIVED = SHOWSUITE.PROPERTY_STATUS_ARCHIVED;

        self.SALE_STATUS_DRAFT = SHOWSUITE.SALE_STATUS_DRAFT;
        self.SALE_STATUS_PENDING = SHOWSUITE.SALE_STATUS_PENDING;
        self.SALE_STATUS_SUBMITTED = SHOWSUITE.SALE_STATUS_SUBMITTED;
        self.SALE_STATUS_VERIFIED = SHOWSUITE.SALE_STATUS_VERIFIED;
        self.SALE_STATUS_APPROVED = SHOWSUITE.SALE_STATUS_APPROVED;
        self.SALE_STATUS_REJECTED = SHOWSUITE.SALE_STATUS_REJECTED;
        self.SALE_STATUS_OTP = SHOWSUITE.SALE_STATUS_OTP;
        self.SALE_STATUS_CHEQUE_ENTERED = SHOWSUITE.SALE_STATUS_CHEQUE_ENTERED;
        self.SALE_STATUS_SPA_ENTERED = SHOWSUITE.SALE_STATUS_SPA_ENTERED;
        self.SALE_STATUS_EXPIRED = SHOWSUITE.SALE_STATUS_EXPIRED;
        self.SALE_STATUS_EXERCISED = SHOWSUITE.SALE_STATUS_EXERCISED;
        self.SALE_STATUS_EXTENDED = SHOWSUITE.SALE_STATUS_EXTENDED;
        self.SALE_STATUS_ABORTED = SHOWSUITE.SALE_STATUS_ABORTED;
        self.SALE_STATUS_INVALID = SHOWSUITE.SALE_STATUS_INVALID;
        self.SALE_STATUS_DONE = SHOWSUITE.SALE_STATUS_DONE;
        self.SALE_STATUS_DELETED = SHOWSUITE.SALE_STATUS_DELETED;
        self.SALE_STATUS_DONE = SHOWSUITE.SALE_STATUS_DONE;
        self.PAYMENT_TYPE_20_REFUND = SHOWSUITE.PAYMENT_TYPE_20_REFUND;
        self.PAYMENT_REFUND_TYPE_10_WAIVER = SHOWSUITE.PAYMENT_REFUND_TYPE_10_WAIVER;

        self.BROKER_ROLE_MAIN_BROKER = SHOWSUITE.BROKER_ROLE_MAIN_BROKER;
        self.BROKER_ROLE_TEAMLEAD = SHOWSUITE.BROKER_ROLE_TEAMLEAD;
        self.BROKER_ROLE_SALES_CONSULTANT = SHOWSUITE.BROKER_ROLE_SALES_CONSULTANT;
        self.PROPERTY_DOCUMENT_KIND_OTP = SHOWSUITE.PROPERTY_DOCUMENT_KIND_OTP;
        self.PROPERTY_DOCUMENT_TYPE_SYSTEM_GENERATED = SHOWSUITE.PROPERTY_DOCUMENT_TYPE_SYSTEM_GENERATED;
        self.ASSET_MODEL_SALE_DOCUMENT = SHOWSUITE.ASSET_MODEL_SALE_DOCUMENT;
        self.BUYER_TYPE_COMPANY = SHOWSUITE.BUYER_TYPE_COMPANY;
        self.BUYER_TYPE_INDIVIDUAL = SHOWSUITE.BUYER_TYPE_INDIVIDUAL;

        self.SALE_REISSUE_EXTENSION = SHOWSUITE.SALE_REISSUE_EXTENSION;
        self.SALE_REISSUE_CHANGE_BUYER_PARTICULARS = SHOWSUITE.SALE_REISSUE_CHANGE_BUYER_PARTICULARS;
        self.SALE_REISSUE_ADD_REMOVE_BUYER = SHOWSUITE.SALE_REISSUE_ADD_REMOVE_BUYER;
        self.SALE_REISSUE_CHANGE_UNIT = SHOWSUITE.SALE_REISSUE_CHANGE_UNIT;
        self.SALE_REISSUE_WITH_BUYER_SIGNING = SHOWSUITE.SALE_REISSUE_WITH_BUYER_SIGNING;

        self.AUTO_REFRESH_TIME = SHOWSUITE.AUTO_REFRESH_TIME;

        /** `include` of the listing request (also sent to the change feed). */
        self.SALES_LIST_INCLUDE = 'eois, properties, units, brokers, beneficiaries, agencies, sale_buyers, question_answers, documents, history, payments, sale_gst_detail, aml_scans_modified';

        /** Sequence of listing requests; only the latest may fill the table. */
        self.list_request_id = 0;

        /**
         * WEB-4686: the page's auto refresh had been disabled ("Temp disabling of
         * auto refresh") because re-requesting the whole list on a timer was too
         * costly. The sales change feed tells the page cheaply when a sale on it
         * (or one that may enter it) changed, and only then is the page re-fetched.
         */
        self.saleChangePoller = SSSaleChangeFeedService.createPoller({
            scope: $scope,
            getParams: function () {
                return {
                    property_id: self.property_id,
                    include: self.SALES_LIST_INCLUDE
                };
            },
            onChanges: function (data) {
                self.applySaleChanges(data);
            }
        });

        // WEB-4212: written back onto the unit after a successful Mark Ready so the
        // button hides without reloading the listing.
        self.KEY_HANDOVER_STATUS_READY = SHOWSUITE.KEY_HANDOVER_STATUS_READY;

        self.QUESTION_MARKER_AML_RISK_ASSESSMENT_LEVEL = SHOWSUITE.QUESTION_MARKER_AML_RISK_ASSESSMENT_LEVEL;
        self.QUESTION_MARKER_AML_RISK_ASSESSMENT_REMARKS = SHOWSUITE.QUESTION_MARKER_AML_RISK_ASSESSMENT_REMARKS;

        self.sale_statuses = [
            {'id': self.SALE_STATUS_PENDING, 'name': 'Pending Buyer Signing'},
            {'id': self.SALE_STATUS_VERIFIED, 'name': 'Approval Pending'},
            {'id': self.SALE_STATUS_APPROVED, 'name': 'Approved'},
            {'id': self.SALE_STATUS_OTP, 'name': 'Pending SPA'},
            {'id': self.SALE_STATUS_SPA_ENTERED, 'name': 'SPA Entered'},
            // {'id': self.SALE_STATUS_EXTENDED, 'name': 'Extended'},
            {'id': self.SALE_STATUS_EXERCISED, 'name': 'Exercised'},
            // {'id': self.SALE_STATUS_EXPIRED, 'name': 'Expired'},
            // {'id': self.SALE_STATUS_INVALID, 'name': 'Invalid'},
            // {'id': self.SALE_STATUS_VERIFIED, 'name': 'Verified'},
            {'id': self.SALE_STATUS_REJECTED, 'name': 'Rejected'},
            {'id': self.SALE_STATUS_ABORTED, 'name': 'Aborted'},
            {'id': self.SALE_STATUS_DONE, 'name': 'Completed'},
        ];
        self.payment_types = self.SSConfigService.getPaymentClauses();

        self.countries = self.SSConfigService.getCountries();
        self.propertyPieChart=[{0:
                [{label:"availableUnits", value : 20},
                    {label:"soldUnits", value :30}]
        }];

        self.today = moment().format('DD/MM/YYYY');
        self.payment_plans = [];

        if (self.SSUserService.isDeveloper()) {
            self.init();
        }
    }

    init() {
        const self = this;

        // Trigger View Event for Sales Payments Page
        self.SSAnalyticsService.saveAnalyticEvent({
                event: self.SSAnalyticsService.ANALYTICS_EVENT_VIEWS_DMS_PAYMENTS,
                user_id: self.SSUtilService.getFromLocalStorage('user').id
            }
        );

        self.order_by = '{"otp_date": "desc"}';
        self.getResultsPage(1);

        self.pagination = {
            current: 1
        };

        if(!self.parameters.id) {
            self.current = 1;
        }
        else {
            self.current = self.parameters.id;
        }

        self.aborted_date = moment().format('DD/MM/YYYY');

        self.pageChanged = function(newPage) {
            self.retrieveApplications(newPage);
            //location.replace('/payments?id=' + self.current);
            if (history.pushState) {
                window.history.replaceState("object or string", "Title", 'payments?id=' + self.current);
            }else {
                document.location.href = 'payments?id=' + self.current;
            }
        };

        self.reissued_sales_total = null;
        self.rejected_sales_total = null;
        self.sales_reissue = null;
        self.property_total = 0;

        self.payment_page =true;
        self.properties = [];
        self.sales = [];
        self.property_id = "";
        self.select_property_id = "";
        self.payment_type = "";
        self.select_otp_date_from = "";
        self.select_otp_date_to = "";
        self.sale_status = "";
        self.projects = [];
        self.limit = 10;
        self.search_by = 'unit_no';

        self.offset = 0;
        self.sales_total = 0;
        self.session_page=null;
        self.tableParams=null;
        self.showPaymentInvoiceModal = false;
        self.dateRangeErrorForPaymentInvoiceModal = false;
        self.showPaymentReceiptModal = false;
        self.dateRangeErrorForPaymentReceiptModal = false;

        self.abort_reasons = self.SSConfigService.getAbortReasons();
        self.updateAbortReasonFilter();

        self.rollbackAbortParams = {};
        self.rollbackAbortStatuses = [
            { id: self.SALE_STATUS_OTP, name: 'OTP Generated' },
            { id: self.SALE_STATUS_SPA_ENTERED, name: 'SPA Entered' },
            { id: self.SALE_STATUS_EXERCISED, name: 'Exercised' }
        ];

        self.prepareDeveloperProperties();
        // self.getAbortedSale();
        // self.getProperty();

        self.page = sessionStorage.getItem("lastname") ? sessionStorage.getItem("lastname") : 1;

        // Calendar
        $('.datepicker').datepicker({changeMonth: true, changeYear: true, dateFormat: 'dd/mm/yy' });


    }

    getResultsPage(pageNumber) {
    }

    updatePage() {
        const self = this;

        if(self.tableParams){
            self.session_page = self.tableParams.page();
            sessionStorage.setItem("lastname", self.session_page);
        }
    }

    openExportSaleApplication() {
        const self = this;

        self.hideModals();
        self.showExport = true;
        self.exportType = "full_sale_data";
        self.payment_type = "";
        self.select_property_id = "";
        self.select_otp_date_from = "";
        self.select_otp_date_to = "";
        self.$timeout(function() { $("select.dashboard-select#property-select").niceSelect('update'); });
        $('#developerSaleApplicationExportModal').modal('show');
    }

    openPaymentInvoicesModal() {
        const self = this;

        self.hideModals();
        self.showPaymentInvoiceModal = true;
        self.dateRangeErrorForPaymentInvoiceModal = false;
        $('#developerSalePaymentInvoicesModal').modal('show');
    }

    openPaymentReceiptModal() {
        const self = this;

        self.hideModals();
        self.showPaymentReceiptModal = true;
        self.dateRangeErrorForPaymentReceiptModal = false;
        $('#developerSalePaymentReceiptsModal').modal('show');
    }

    getProperty(show_loading = true) {
        const self = this;

        let property_id = self.property_id;
        self.property = self.properties;
        let _property_total = 0;

        if(property_id)
        {
            jQuery.each(self.property, function(i, property){
                if(property_id == property.id)
                {
                    _property_total += self.SSAppService.getSoldUnits(property);
                }
            });
        }
        else{
            jQuery.each(self.property, function(i, property){
                _property_total += self.SSAppService.getSoldUnits(property);
            });
        }

        self.property_total = _property_total;
        // let url = 'sec/developer/properties/';

        // if(show_loading){
        //     loading(true);
        // }

        // self.SSHttpService.getAPIRequest(url).then(function (response) {
        //     if(show_loading){
        //         loading(false);
        //     }
        //
        //     if (response instanceof Error) {
        //         self.SSAlertService.parseAndDisplayError(response);
        //         return;
        //     }
        //
        //
        // });
    }

    getSPADueDate(date){
        const self = this;

        if(!date){
            return '--';
        }

        let spa_due_date = null;

        // SPA Due Date is 'otp_date + 14 days'
        try{
            spa_due_date = moment(date, "YYYY-MM-DD").add(14, 'days').format('DD/MM/YYYY');
        }
        catch(ex){
            console.log(ex);
        }

        return spa_due_date ? spa_due_date : '--';
    }

    exportApplications() {
        const self = this;
        let url = "";
        let params = {
            status: "12,20,21,30,31,32,34,35,37,50",
            property_id: self.select_property_id
        };
        if(self.exportType === "full_sale_data"){
            url = "sec/developer/sales/application-export";
            params['otp_date_from'] =
                self.select_otp_date_from;
            params['otp_date_to'] =
                self.select_otp_date_to;
        }else{
            url = "sec/developer/sales/sales-payments-instruments-export";
            params['from_date'] =
                self.select_otp_date_from;
            params['to_date'] =
                self.select_otp_date_to;
            if(self.payment_type){
                params['payment_type'] = self.payment_type.join(",");
            }
        }
        url = self.SSHttpService.getApiURL(url);
        url += (url.indexOf('?') === -1 ? '?' : '&');
        url += $.param(params);
        self.$window.location.href = url;

        self.hideModals();
        self.showExport = false;
        self.SSAlertService.success('Success!', 'Sales application export successfully.');
    }

    sendPaymentInvoiceEmail() {
        this._sendPaymentInvoiceEmailRequest("sec/developer/sales/send-tax-invoice-email-excel");
    }

    sendPaymentInvoiceEmailPdf() {
        this._sendPaymentInvoiceEmailRequest("sec/developer/sales/send-tax-invoice-email-pdf");
    }

    _sendPaymentInvoiceEmailRequest(url) {
        const self = this;

        let fromDate = moment(self.select_otp_date_from, "DD/MM/YYYY");
        let toDate = moment(self.select_otp_date_to, "DD/MM/YYYY");
        let params = {
            property_id: self.select_property_id
        };
        if(fromDate.isValid() && toDate.isValid() && !fromDate.isSameOrBefore(toDate)) {
            self.dateRangeErrorForPaymentInvoiceModal = true;
            return;
        }
        if(fromDate.isValid()) params.from_date = fromDate.format("YYYY-MM-DD");
        if(toDate.isValid()) params.to_date = toDate.format("YYYY-MM-DD");

        loading(true);
        self.SSHttpService.postAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.SSAlertService.success('Success!', 'Sales Payment Invoices sent successfully.');
            self.hideModals();
            self.showPaymentInvoiceModal = false;
        });
    }

    sendPaymentReceiptEmail() {
        const self = this;

        let url = "sec/developer/sales/send-tax-receipt-email-pdf";
        let fromDate = moment(self.select_otp_date_from, "DD/MM/YYYY");
        let toDate = moment(self.select_otp_date_to, "DD/MM/YYYY");
        let params = {
            property_id: self.select_property_id
        };
        if(fromDate.isValid() && toDate.isValid() && !fromDate.isSameOrBefore(toDate)) {
            self.dateRangeErrorForPaymentReceiptModal = true;
            return;
        }
        if(fromDate.isValid()) params.from_date = fromDate.format("YYYY-MM-DD");
        if(toDate.isValid()) params.to_date = toDate.format("YYYY-MM-DD");

        loading(true);
        self.SSHttpService.postAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.SSAlertService.success('Success!', 'Official Receipts sent successfully.');
            self.hideModals();
            self.showPaymentReceiptModal = false;
        });
    }


    onEnterKeyPress(event) {
        const self = this;
        if (event.charCode == 13) //Check enter key pressed
        {
            self.updateFilter();
        }
    }

    prepareDeveloperProperties() {
        const self = this;

        let url = 'sec/developer/properties/list';
        let params = {
            'include': 'unit_statuses',
            status: '30,50', // Approved, Listed
        };
        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if(response.data && response.data.properties){
                $.each(response.data.properties, function(index, property){
                    if(property.status != self.PROPERTY_STATUS_ARCHIVED){
                        self.properties.push(property);
                    }
                });
            }

            self.properties = self.properties.sort(function(a, b) {
                return b.id - a.id; // descending by id
            });
            if(self.properties && self.properties.length){
                const savedPropertyId = self.SSUtilService.getFromLocalStorage('lastPropertyId');
                if (savedPropertyId && self.properties.some(p => p.id == savedPropertyId)) {
                    self.property_id = savedPropertyId;
                } else {
                    self.property_id = parseInt(self.properties[0].id);
                    self.SSUtilService.saveToLocalStorage("lastPropertyId", self.property_id);
                }
            }

            self.$timeout(function() { $("select.dashboard-select#property-select").niceSelect('update'); });

            self.retrieveApplications(self.current);
        });

    }

    displayControls(index, sale) {
        const self = this;

        self.selected_sale = sale;

        let close = true;
        if ($("#control_" + index).hasClass("show")) {
            close = false;
        }

        $(".controls").removeClass("show");

        if (close) {
            $("#control_" + index).toggleClass("show");
        }
    }


    returnSales(sale) {
        const self = this;
        self.sale=sale;
        self.sale.remarks='';
        $('#returnSalesRemarksModal').modal('show');
    }

    returnSales_1(sale) {
        const self = this;

        self.SSConfirmationService.getConfirmed(
            'Confirm!',
            'Are you sure you want to make this change?',
            self.SSConfirmationService.TYPE_DEFAULT,
            function(confirmationStatus) {


                        self._returnSales(sale);

            }
        );
    }

    onAcceptConfirm() {
        const self = this;

        let url = 'sec/developer/sales/' + self.selected_sale.id + '/status';
        let params = {
            'status': self.SALE_STATUS_APPROVED
        };

        loading(true);
        self.SSHttpService.putAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.hideModals();
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            //Update sale status
            self.selected_sale.status = self.SALE_STATUS_APPROVED;
            self.SSAlertService.success('Success!', 'Sale is approved successfully.');

            self.onOTP();
        });
    }

    onOTP() {
        const self = this;

        self.hideModals();

        self.showOTPModal = true;
        $('#developerSaleApplicationOTPModal').modal('show');
    }

    onRejectConfirm() {
        const self = this;

        let url = 'sec/developer/sales/' + self.selected_sale.id + '/status';
        let params = {
            'status': self.SALE_STATUS_REJECTED
        };

        loading(true);
        self.SSHttpService.putAPIRequest(url, params).then(function (response) {
            loading(false);
            self.hideModals();
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            //Update sale status
            self.selected_sale.status = self.SALE_STATUS_REJECTED;
            self.SSAlertService.success('Success!', 'Sale is rejected successfully.');
        });
    }

    abortSale(sale) {
        const self = this;
        self.SSConfirmationService.getConfirmed(
            'Confirm!',
            'Are you sure you want to abort this sale?',
            self.SSConfirmationService.TYPE_DEFAULT,
            function() {
                self.OTPService.getVerified(
                    self.OTPService.TYPE_SESSION_2FA,
                    function(data){

                    let url = 'sec/developer/sales/' + sale.id + '/status';
                    let params = {
                        'status': self.SALE_STATUS_ABORTED
                    };
                    loading(true);
                    self.SSHttpService.putAPIRequest(url, params).then(function (response) {
                        loading(false);
                        if (response instanceof Error) {
                            if (response.sub_code == 305015 || response.sub_code == 412002) {
                                self.SSAlertService.danger("Please Note:", "This sale has been updated by another user. You will not be able to make further updates to this sale.")
                                return;
                            }
                            self.SSAlertService.parseAndDisplayError(response);
                            return;
                        }

                        // Update sale status
                        sale.status = self.SALE_STATUS_ABORTED;
                        self.SSAlertService.success('Sale is aborted successfully.');
                    });
                });

            }
        );

    }

    rejectSale(sale) {
        const self = this;

        self.SSConfirmationService.getConfirmed(
            'Confirm!',
            'Are you sure you want to reject this sale?',
            self.SSConfirmationService.TYPE_DEFAULT,
            function() {

                let url = 'sec/developer/sales/' + sale.id + '/status';
                let params = {
                    'status': self.SALE_STATUS_REJECTED
                };

                loading(true);
                self.SSHttpService.putAPIRequest(url, params).then(function (response) {
                    loading(false);
                    if (response instanceof Error) {
                        if (response.sub_code == 305015 || response.sub_code == 412002) {
                            self.SSAlertService.danger("Please Note:", "This sale has been updated by another user. You will not be able to make further updates to this sale.")
                            return;
                        }
                        self.SSAlertService.parseAndDisplayError(response);
                        return;
                    }

                    // Update sale status
                    sale.status = self.SALE_STATUS_REJECTED;
                    self.SSAlertService.success('Sale is rejected successfully.');
                });

            }
        );
    }

    generateOTP() {
        const self = this;

        let url = 'sec/developer/sales/' + self.selected_sale.id + '/generate-otp';

        loading(true);
        self.SSHttpService.postAPIRequest(url).then(function (response) {
            if (response instanceof Error) {
                loading(false);
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.hideModals();
            self.selected_sale.status = self.SALE_STATUS_OTP;

            let sale_document = response.data.sale_document;
            self.selected_sale.documents.push(sale_document);

            self.SSAlertService.success('Success!', 'OTP is generated successfully.');

            url = 'sec/assets/presigned-url';
            let params = {
                'model': self.ASSET_MODEL_SALE_DOCUMENT,
                'id': sale_document.id
            };
            self.SSHttpService.getAPIRequest(url, params).then(function (response) {
                loading(false);
                if (response instanceof Error) {
                    self.SSAlertService.parseAndDisplayError(response);
                    return;
                }

                //Open OTP in new tab
                window.open(response.data.presigned_url, '_blank');
            });
        });
    }

    _returnSales(sale) {
        const self = this;
        let url = 'sec/developer/sales/'+sale.id+'/return';
        let params = {
            'saleId': sale.id,
            'remarks': sale.remarks
        };

        loading(true);
        self.SSHttpService.putAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                if (response.sub_code == 305015 || response.sub_code == 412002) {
                    self.SSAlertService.danger("Please Note:", "This sale has been updated by another user. You will not be able to make further updates to this sale.")
                    return;
                }
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            //Update sale status
            self.returnStatus = response.data.sale;
            sale.status=self.returnStatus.status;
            self.SSAlertService.success('Success!', 'Sale Return updated successfully.');
            sale.last_remarks = angular.copy(sale.remarks);
        });
    }

    searchAgent() {
        const self = this;

        self.agents = [];
        let url = 'agents/search';
        let params = {
            criteria: self.criteria
        };

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
          loading(false);

          if (response instanceof Error) {
            self.SSAlertService.parseAndDisplayError(response);
            return;
          }

          if (response.data && response.data.agents) {
            self.agents = response.data.agents;

            $.each(self.agents, function (index, agent) {
              if (self.SSEoiService.brokers_obj.find(x => x.user_id == agent.user_id)) {
                  agent["unselected"] = false;
              } else {
                  agent["unselected"] = true;
              }
            })
          }

          self.searched = true;
        });
    }

    //-------------------------------------------
    // Sale Re-issue

    showReissuePopup(sale) {
        const self = this;

        self.reissueParams = {
            sale_id: sale.id,
            remarks: sale.allocation_remarks,
        };

        self.reissue_sale = sale;

        self.error_reissue_reason = false;
        $('.datepicker').datepicker({changeMonth: true, changeYear: true, dateFormat: 'dd/mm/yy' });

        if(sale.otp_aborted_date && sale.otp_aborted_date!= "0000-00-00 00:00:00"){
            self.reissue_aborted_date = moment(sale.otp_aborted_date).format('DD/MM/YYYY');
        }
        else{
            self.reissue_aborted_date = moment().format('DD/MM/YYYY');
        }

        jQuery('#ReIssueModal').modal('show');
    }


    abortSale(sale, url) {
        const self = this;

        self.abort_sale = sale;
        self.abort_sale_url = url+'/'+sale.id+'/details?id='+self.current+'&status=abort';
        self.hideModals();

        self.$timeout(function() { $('#abortDatepicker_' + sale.id).datepicker({ dateFormat: 'dd/mm/yy' }); });

        self.error_abort_reason = false;
        if(sale.otp_aborted_date && sale.otp_aborted_date != "0000-00-00 00:00:00"){
            self.aborted_date = moment(sale.otp_aborted_date).format('DD/MM/YYYY');
        }
        else{
            self.aborted_date = moment().format('DD/MM/YYYY');
        }
        // Show confirmation pop up, 'Abort Reason'
        jQuery('#abortSaleModal').modal('show');
    }

    _abortSale() {
        const self = this;

        self.error_abort_reason = false;
        let sale = self.abort_sale;
        self.OTPService.getVerified(self.OTPService.TYPE_SESSION_2FA, function(data){

            let url = 'sec/developer/sales/' + sale.id + '/status';

            if(!self.abortSaleParams || !self.abortSaleParams.abort_reason){
                self.error_abort_reason = true;
                return;
            }

            let abort_utcFormat = self.getDateParam(self.aborted_date);

            let params = self.abortSaleParams;
            params.status = self.SALE_STATUS_ABORTED;
            params.otp_aborted_date = abort_utcFormat ? abort_utcFormat : null;

            loading(true);
            self.SSHttpService.putAPIRequest(url, params).then(function (response) {
                loading(false);
                self.hideModals();
                if (response instanceof Error) {
                    self.SSAlertService.parseAndDisplayError(response);
                    return;
                }

                // Update sale with latest info
                sale.status = self.SALE_STATUS_ABORTED;
                sale.abort_reason = self.abortSaleParams.abort_reason;
                sale.last_remarks = self.abortSaleParams.remarks;
                sale.otp_aborted_date = self.getDateParam(self.aborted_date);
                // self.SSAlertService.success('Sale is aborted successfully.');
                // self.$window.location.href = self.abort_sale_url;
                let message = 'Sale aborted successfully, do you want to continue to add refund entry?';
                self.SSConfirmationService.getConfirmed("Confirm!", message,
                    self.SSConfirmationService.CANCEL_PROCEED,
                    function (selectedOption) {
                        if(selectedOption){
                            self.$window.location.href = self.abort_sale_url;
                        } else {
                            //
                        }
                    }
                );

            });
        });
    }

    rollbackAbortSale(sale) {
        const self = this;

        self.rollback_abort_sale = sale;
        self.rollbackAbortParams = {};
        self.error_rollback_status = false;
        self.error_rollback_remarks = false;
        self.error_rollback_message = null;
        self.hideModals();

        jQuery('#rollbackAbortSaleModal').modal('show');
    }

    _rollbackAbortSale() {
        const self = this;

        self.error_rollback_status = false;
        self.error_rollback_remarks = false;
        self.error_rollback_message = null;

        let sale = self.rollback_abort_sale;

        if (!self.rollbackAbortParams.status) {
            self.error_rollback_status = true;
        }
        if (!self.rollbackAbortParams.remarks) {
            self.error_rollback_remarks = true;
        }
        if (self.error_rollback_status || self.error_rollback_remarks) {
            return;
        }

        self.OTPService.getVerified(self.OTPService.TYPE_SESSION_2FA, function(data) {

            let url = 'sec/developer/sales/' + sale.id + '/rollback-abort';

            let params = {
                status: self.rollbackAbortParams.status,
                remarks: self.rollbackAbortParams.remarks
            };

            loading(true);
            self.SSHttpService.putAPIRequest(url, params).then(function(response) {
                loading(false);
                if (response instanceof Error) {
                    // WEB-3321 (re-open): the server now blocks the rollback for two business
                    // scenarios (a Refund/Abort clause still on the sale, or the unit having been
                    // re-assigned to another EOI) and returns a descriptive message. Keep the modal
                    // open and surface that message inline so the user can act on it (e.g. remove the
                    // Refund clause from Sale Details, then retry). parseAndDisplayError still fires
                    // for the global toast and status-code-specific handling (session/permission).
                    self.error_rollback_message = (response.data && response.data.message)
                        || response.message
                        || 'Unable to rollback the abort for this sale. Please try again or contact support.';
                    self.SSAlertService.parseAndDisplayError(response);
                    return;
                }

                self.hideModals();
                sale.status = self.rollbackAbortParams.status;
                sale.last_remarks = self.rollbackAbortParams.remarks;
                self.SSAlertService.success('Sale abort has been rolled back successfully.');
            });
        });
    }

    /**
     * WEB-4212: Mark the sale's unit as ready for Key Handover appointment booking.
     *
     * Same action as the bulk "Mark Ready" button on Projects > Key Handover >
     * Units (KeyHandoverUnitSelectionController.markAsReady), reduced to the one
     * unit behind this sale so the finance team can confirm payments and release
     * the unit from the Sales & Payments listing.
     *
     * Unlike the Key Handover page — where the user has already ticked the units
     * explicitly — this is a single click next to Abort/Re-issue and it emails the
     * buyers, so it is put behind a confirmation.
     *
     * @param {Object} sale Sale row from the listing; sale.unit carries id and property_id.
     * @remarks The server only writes key_handover_status when it is currently null,
     *          but it sends the buyer notification + email on every call. The button is
     *          hidden once the unit is marked (see payments.blade.php) and the status is
     *          set locally on success to keep that gate honest without a list reload.
     *          sale.unit is a shared object across rows for the same unit, so a re-sold
     *          unit's other rows update too — which is what we want.
     */
    markUnitReady(sale) {
        const self = this;

        if (!sale || !sale.unit) {
            return;
        }

        self.SSConfirmationService.getConfirmed(
            'Confirm!',
            'Mark unit ' + self.SSUtilService.getFullUnitNumber1(sale.unit, false)
                + ' as ready for Key Handover appointment booking? The buyer(s) will be notified.',
            self.SSConfirmationService.TYPE_DEFAULT,
            function () {

                let url = 'sec/developer/properties/' + sale.unit.property_id + '/units/key-handover/mark-as-ready';
                let params = {
                    unit_ids: sale.unit.id.toString()
                };

                loading(true);
                self.SSHttpService.postAPIRequest(url, params).then(function (response) {
                    loading(false);
                    if (response instanceof Error) {
                        // The server explains why a unit cannot be marked (no sale buyers,
                        // no sale_buyers_count, project not listed) via ssAbort, which lands
                        // on response.message — show that instead of a generic failure.
                        if (response.message) {
                            self.SSAlertService.danger('Not Allowed!', response.message);
                        } else {
                            self.SSAlertService.parseAndDisplayError(response);
                        }
                        return;
                    }

                    sale.unit.key_handover_status = self.KEY_HANDOVER_STATUS_READY;
                    self.SSAlertService.success('Success!', 'Unit marked as ready successfully.');
                });
            }
        );
    }

    getDateParam(date){
        const self = this;

        if(date != '' && date != null) {
            var now = new moment();
            var res = date.split("/", 3);
            var abortDate =  res[2] + '-' + res[1] + '-' + res[0] + ' ' + now.format("HH:mm:ss");
            var abort_localDate = new Date(self.parseDate(abortDate));
            var abort_utcFormat = moment(abort_localDate).utc().format('YYYY-MM-DD HH:mm:ss');

            return abort_utcFormat;
        }
        else{
            return null;
        }
    }

    parseDate(date) {
        const self = this;

        const parsed = Date.parse(date);
        if (!isNaN(parsed)) {
            return parsed;
        }

        return Date.parse(date.replace(/-/g, '/').replace(/[a-z]+/gi, ' '));
    }

    updateAbortReasonFilter(){
        const self = this;

        self.$timeout(function() { $(".abort-reason-select").niceSelect(); });
    }

    reissue() {
        const self = this;

        self.error_reissue_reason = false;

        self.OTPService.getVerified(
            self.OTPService.TYPE_SESSION_2FA,
            function(data){
                let url = 'sec/developer/sales/' + self.reissueParams.sale_id + '/reissue';
                let params = self.reissueParams;

                // CHECK IF ABORT/RE-ISSUE REASON IS SELECTED
                if(!self.reissue_reason){
                    self.error_reissue_reason = true;
                    return;
                }

                let abort_utcFormat = self.getDateParam(self.reissue_aborted_date);

                params.abort_reason = self.reissue_reason;
                params.otp_aborted_date = abort_utcFormat;

                loading(true);
                self.SSHttpService.putAPIRequest(url, params).then(function (response) {
                    loading(false);
                    self.hideModals();

                    if (response instanceof Error) {
                        if (response.sub_code == 305015 || response.sub_code == 412002) {
                            self.SSAlertService.danger("Please Note:", "This sale has been updated by another user. You will not be able to make further updates to this sale.")
                            return;
                        }
                        self.SSAlertService.parseAndDisplayError(response);
                        return;
                    }

                    self.SSAlertService.success('Success!', 'Sale reissued successfully.');

                    // If reissue reason is 50 (Re-issue with Buyer Signing)
                    // then redirect to edit details page
                    if(self.reissueParams.reason == self.SALE_REISSUE_WITH_BUYER_SIGNING){
                        self.$window.location.href = '/developer/sales/payments/' + response.data.new_sale.id + '/reissue';
                    }

                    // Update sale status
                    let sale = response.data.sale;

                    jQuery.each(self.sales, function (i, _sale) {
                        if (_sale.id == sale.id) {
                            angular.merge(_sale, sale);
                            _sale.last_remarks = angular.copy(self.reissueParams.remarks);
                            return false;
                        }
                    });

                });
        });
    }

    getReissueReasonLabel(code) {
        const self = this;

        if(!code){
            return '--';
        }

        // Check the type and return respective response
        if(typeof code === 'number'){
            let name = self.SSConfigService.getReissueTypeName(code);
            return  name ? name : '--';
        }
        else if(typeof code === 'object'){
            return  '--';
        }
        else{
            return code;
        }
    }

    //-------------------------------------------

    executeExtend(sale) {
        const self = this;

        if (!(self.extendedExpiryDate)) return; // Skip, no data

        let url = 'sec/developer/sales/' + sale.id + '/extend';
        let params = {
            expiry_date: self.convertDateToServerFormat(self.extendedExpiryDate)
        };

        loading(true);
        self.SSHttpService.putAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                if (response.sub_code === 305015 || response.sub_code === 412002) {
                    self.SSAlertService.danger("Please Note:", "This sale has been updated by another user. You will not be able to make further updates to this sale.")
                    return;
                }
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            // Update sale
            //sale = self.sales.find(x => x.id === sale.id);
            sale.status = response.data.sale.status;
            sale.expiry_date = response.data.sale.expiry_date;
            self.SSAlertService.success('Success!', 'Sale Expiry Date Extended successfully.');
        });
    }

    convertDateToServerFormat(date) {
        if (date) {
            let array = date.split("/", 3);
            return array[2] + '-' + array[1] + '-' + array[0];
        }
    }

    viewOTP() {
        const self = this;

        let sale_document = self.selected_sale.documents.filter(x => x.type === self.PROPERTY_DOCUMENT_TYPE_SYSTEM_GENERATED && x.document_kind === self.PROPERTY_DOCUMENT_KIND_OTP);

        if (sale_document.length > 0) {
            let url = 'sec/assets/presigned-url';
            let params = {
                'model': self.ASSET_MODEL_SALE_DOCUMENT,
                'id': sale_document[0].id
            };

            loading(true);
            self.SSHttpService.getAPIRequest(url, params).then(function (response) {
                loading(false);
                if (response instanceof Error) {
                    self.SSAlertService.parseAndDisplayError(response);
                    return;
                }

                //Open OTP in new tab
                window.open(response.data.presigned_url, '_blank');
            });
        }
    }

    prepareSaleStatuses() {
        const self = this;

        self.$timeout(function() { $("select.dashboard-select#status-select").niceSelect('update'); });
    }

    onReview(sale) {
        const self = this;

        self.$window.location.href = '/developer/sales/applications/review?sale_id=' + sale.id;

    }

    onAccept(sale) {
        const self = this;

        self.hideModals();

        self.showAccept = true;
        $('#developerSaleApplicationAcceptModal').modal('show');
    }

    onReject(sale) {
        const self = this;

        self.hideModals();

        self.showReject = true;
        $('#developerSaleApplicationRejectModal').modal('show');
    }

    previousPage() {
        const self = this;

        self.offset = self.offset - parseInt(self.limit);
        self.retrieveApplications();
    }

    nextPage() {
        const self = this;

        self.offset = self.offset + parseInt(self.limit);
        self.retrieveApplications();
    }

    updateFilter() {
        const self = this;
        // sessionStorage.setItem("sale_status", self.sale_status);
        // sessionStorage.setItem("search_by", self.search_by);
        // sessionStorage.setItem("search_value", self.search_value);
        // sessionStorage.setItem("property_id", self.property_id);

        self.offset = 0;
        self.page = 1;
        self.retrieveApplications(self.page);
    }

    onViewSummary(sale) {
        const self = this;

        self.$window.location.href = '/developer/sales/applications/summary?sale_id=' + sale.id;
    }

    getStatus(show_loading = true) {
      const self = this;
        let url = 'config';

        if(show_loading){
            loading(true);
        }
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            if(show_loading){
                loading(false);
            }

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            //get sale status
            self.saleStatus = response.data.sale_statuses;
        });
    }

    getAbortedSale() {
      const self = this;

        let url = 'sec/developer/sales';
        let params = {
            'property_id': self.property_id,
            'status': self.SALE_STATUS_ABORTED,
            'limit': 5000,
            'offset': 0,
            'include': 'eois, properties, units, brokers, agencies, sale_buyers, question_answers, documents, history',
            'send_total_count': true,
        };

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            //get sale status
            self.saleAborted = response.data.total_count;

        });

    }

    getReissuedSales(show_loading = true) {
        const self = this;

        self.reissued_sales = [];
        self.rejected_sales = [];

        let url = 'sec/developer/sales';
        let params = {
            'status': '21,35',
            'limit': 5000,
            'offset': 0,
        };

        if(self.property_id){
            params.property_id = self.property_id;
        }

        if(show_loading){
            loading(true);
        }

        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            if(show_loading){
                loading(false);
            }

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            //get sale status
            self.sales_reissue = response.data.sales;

            if (self.sales_reissue) {
                jQuery.each(self.sales_reissue, function (i, sale) {
                    if(sale.reissued_from_sale_id || sale.reissued) {
                        self.reissued_sales.push(sale);
                    }
                    if(sale.status == self.SALE_STATUS_REJECTED)
                    {
                        self.rejected_sales.push(sale);
                    }
                });
            }
            self.reissued_sales_total = self.reissued_sales.length;
            self.rejected_sales_total = self.rejected_sales.length;
        });
    }

    checkColor(sale) {
        const self = this;
        let color = null;

        if (sale.status) {
            if (sale.status == self.SALE_STATUS_PENDING
                || sale.status == self.SALE_STATUS_EXTENDED
                || sale.status == self.SALE_STATUS_VERIFIED
            ) {
                color = 'orange';
            } else if (sale.status == self.SALE_STATUS_REJECTED
                || sale.status == self.SALE_STATUS_EXPIRED
                || sale.status == self.SALE_STATUS_ABORTED
            ) {
                color = 'red';
            } else if (sale.status == self.SALE_STATUS_EXERCISED) {
                color = 'green';
            }
            return color;
        }
    }

    checkStatus(sale){
        const self = this;

        let status = null;
        let statusDetail = null;
        let color = null;

        if(sale.status) {
        jQuery.each(self.saleStatus, function (i, status) {
                if(status.id === sale.status){
                    statusDetail = status.display;
                    return false;
                }
            });
        }
        return statusDetail;
    }

    /**
     * Sale statuses the listing shows for the selected status filter.
     *
     * @returns {Array<number>} Status ids, as sent (comma-joined) to `sec/developer/sales`.
     * @remarks WEB-4686: shared by the list load and the change-feed handler, which
     *          needs the same set to tell whether a changed sale belongs on the page.
     */
    getStatusFilter() {
        const self = this;

        let status = [];

        if (!self.sale_status) {
            status = [
                self.SALE_STATUS_VERIFIED,
                self.SALE_STATUS_REJECTED,
                self.SALE_STATUS_APPROVED,
                self.SALE_STATUS_OTP,
                self.SALE_STATUS_CHEQUE_ENTERED,
                self.SALE_STATUS_SPA_ENTERED,
                self.SALE_STATUS_EXTENDED,
                self.SALE_STATUS_EXERCISED,
                self.SALE_STATUS_EXPIRED,
                self.SALE_STATUS_INVALID,
                self.SALE_STATUS_ABORTED,
                self.SALE_STATUS_DONE
            ];
        }
        else {
            status = [self.sale_status];
        }

        if (self.search_value && !self.sale_status) {
            status.push(self.SALE_STATUS_ABORTED);
        }

        return status;
    }

    /**
     * Load the current page of the listing.
     *
     * @param {number}  page                Page to load.
     * @param {boolean} [show_loading=true] False for a silent refresh (change feed): no
     *                                      spinner and the alert box is left alone.
     * @returns {void}
     * @remarks WEB-4686: the sales change feed is re-baselined BEFORE the list read so
     *          a change landing between the two is picked up by the next poll.
     */
    retrieveApplications(page, show_loading = true) {
        const self = this;

        if (show_loading) {
            self.SSAlertService.message = null;
        }
        let offset = null;
        let status = self.getStatusFilter();

        if (self.autoRefreshSaleApplications) {
            self.$timeout.cancel(self.autoRefreshSaleApplications);
        }

        offset = (page*self.limit) - self.limit;

        if(page) {
            self.current = page;
        }

        let url = 'sec/developer/sales';
        let params = {
            'property_id': self.property_id,
            'status': status.join(','),
            'limit': self.limit,
            'offset': offset,
            'include': self.SALES_LIST_INCLUDE,
            'send_total_count': true,
            'order': self.order_by
        };

        if (self.search_value) {
            params[self.search_by] = self.search_value;
        }

        // Only the latest request may fill the table — a silent refresh and a
        // user-triggered load can overlap.
        const request_id = ++self.list_request_id;

        if(show_loading){
            loading(true);
        }
        self.saleChangePoller.rebase().then(function () {
            return self.SSHttpService.getAPIRequest(url, params);
        }).then(function (response) {
            if(show_loading){
                loading(false);
            }

            if (request_id !== self.list_request_id) {
                return;
            }

            if (response instanceof Error) {
                if (show_loading) {
                    self.SSAlertService.parseAndDisplayError(response);
                }
                return;
            }

            self.sales = response.data.sales;
            self.total_count=response.data.total_count;

            self.sales_total = response.data.total_count;

            if (self.sales) {
                jQuery.each(self.sales, function (i, sale) {

                    // Filter AML Risk Assessment Questions
                    if(sale.question_answers){
                        $.each(sale.question_answers, function(i, answer){
                            if(self.SSUtilService.compareQuestionMarker(answer.marker, self.QUESTION_MARKER_AML_RISK_ASSESSMENT_LEVEL)){
                                sale.risk_assessment_level = answer.answer_text;
                            }
                            if(self.SSUtilService.compareQuestionMarker(answer.marker, self.QUESTION_MARKER_AML_RISK_ASSESSMENT_REMARKS)){
                                sale.risk_assessment_remarks = answer.answer_text;
                            }
                        });
                    }

                    if(sale.spa_date && sale.spa_date!='0000-00-00 00:00:00') {
                        sale.actual_expiry_date = self.getExpiryDate(sale.spa_date);
                    }
                    if(sale.history) {
                         jQuery.each(sale.history, function (i, record) {
                                if(record.status==self.SALE_STATUS_SPA_ENTERED){
                                    sale.spaDate=record.created_at;
                                    sale.expiryDate=record.created_at;
                                }
                                if(record.status==self.SALE_STATUS_EXERCISED){
                                    sale.exercisedDate=record.created_at;
                                    sale.expiryDate=record.created_at;
                                }
                                if(record.status==self.SALE_STATUS_EXTENDED){
                                    sale.expiryDate=record.created_at;
                                    sale.saleExtended = true;
                                }
                                sale.remark=record.remarks;

                            });
                    }
                    sale.aml = sale.aml ? JSON.parse(sale.aml) : null;

                    sale.last_remarks = '';

                    if (sale.hasOwnProperty('history') && sale.history.length > 0) {
                        sale.last_remarks = sale.history[sale.history.length - 1].remarks;
                    }
                });
            }

            let brokers = response.data.brokers;

            //Process broker and agency
            $.each(self.sales, function( index, sale ) {

                if(sale.sale_gst_detail){
                    sale.gst_percent = sale.sale_gst_detail.gst_percent;
                }

                let agency = response.data.agencies ? response.data.agencies.find(x => x.id === sale.agency_id) : {};
                sale["agency"] = agency;

                /** WEB-3000 Web: AMS/DMS - Showing incorrect agent name
                 * If sale has brokers, Check for Buyer Agent(MAIN_BROKER) and set as main broker against sale
                 * If Main Broker (Buyer Agent) not found, set Sale Consultant as main_broker
                 * If Sale Consultant not found, set Team IC as main_broker **/
                if(sale.brokers){
                    let main_broker_user_id = null;
                    if(sale.brokers.find(x => x.broker_role === self.BROKER_ROLE_MAIN_BROKER)){ // Check sale has Buyer Agent(MAIN_BROKER)
                        main_broker_user_id = sale.brokers.find(x => x.broker_role === self.BROKER_ROLE_MAIN_BROKER).broker_user_id;
                    } else if(sale.brokers.find(x => x.broker_role === self.BROKER_ROLE_SALES_CONSULTANT)){ // Check sale has Sale Consultant
                        main_broker_user_id = sale.brokers.find(x => x.broker_role === self.BROKER_ROLE_SALES_CONSULTANT).broker_user_id;
                    } else if(sale.brokers.find(x => x.broker_role === self.BROKER_ROLE_TEAMLEAD)){ // Check sale has Team Lead
                        main_broker_user_id = sale.brokers.find(x => x.broker_role === self.BROKER_ROLE_TEAMLEAD).broker_user_id;
                    }

                    sale['main_broker'] = brokers ? brokers.find(x => x.user_id === main_broker_user_id) : null;
                }

                sale['buyers'] = [];

                //Check if the sale is corporate
                if(!!sale.sale_buyers[0]){
                    if (JSON.parse(sale.sale_buyers[0].data).type === self.BUYER_TYPE_COMPANY) {
                        sale.is_corporate = true;
                    }
                }

                $.each(sale.sale_buyers, function(index, buyer) {
                    let processed_buyer = JSON.parse(buyer.data);
                    sale['buyers'].push(processed_buyer);
                });

                sale["eoi"] = response.data.eois.find(x => x.id === sale.eoi_id);
                let unit = response.data.units.find(x => x.id === sale.unit_id);

                sale["unit"] = unit;

                let property = self.properties.find(x => x.id === sale.unit.property_id);

                sale['property'] = property;
                sale['property_name'] = property? property.name : null;
                sale['property_short_code'] = property? property.short_code : null;

                sale["psf"] = unit.size_ft2 ? self.SSAppService.getRoundOffValue(sale.price / unit.size_ft2, (property? property.country: null)) : '--';

                // Payments calculations
                if(sale.payments && sale.payments.length > 0){
                    try{
                        // Get last sale to update 'Current Clause'
                        let current_clause = sale.payments[sale.payments.length - 1];

                        if(current_clause){
                            // WEB-4012: a Waiver and a real Refund are both payment type 20
                            // hanging off the same "REFUND" clause, so a clause lookup labels
                            // both of them "REFUND". When the latest payment is a Waiver
                            // (refund_type = 10) show that instead — resolved here, ahead of the
                            // clause lookup, because the no-payment-plan branch below fills
                            // current_clause in asynchronously. The truthy check on refund_type
                            // guards against a loose `null == undefined` match on a page that
                            // did not inject the constant.
                            // The type check mirrors the sale-details guard: a row carrying
                            // refund_type = 10 but a type other than 20 is not a waiver, and
                            // without the check it would lose its real clause name entirely.
                            if (current_clause.refund_type
                                && current_clause.type == self.PAYMENT_TYPE_20_REFUND
                                && current_clause.refund_type == self.PAYMENT_REFUND_TYPE_10_WAIVER) {
                                sale["current_clause"] = 'Interest Waiver';
                            } else if (current_clause.payment_plan_clause_id) {
                                //Check payment plan first
                                let payment_plan = self.payment_plans.find(x => x.id === sale.payment_plan_id);
                                if (payment_plan) {
                                    sale["current_clause"] = self.getPaymentClauseName(payment_plan.clauses, current_clause.payment_plan_clause_id);
                                } else {
                                    self.getPaymentClauses(sale, current_clause.payment_plan_clause_id);
                                }
                            } else if (current_clause.type) {
                                sale["current_clause"] = self.SSConfigService.getPaymentClauseName(current_clause.type);
                            } else {
                                sale["current_clause"] = "--";
                            }
                        }

                        let total_amount_paid = 0;
                        let total_due_amount = 0;
                        let late_payment_amount = 0;
                        let interest_paid_amount = 0;
                        // Calculate 'Total Amount Paid' and 'Outstanding Amount'
                        $.each(sale.payments, function(_index, payment){
                            if(payment.type != self.PAYMENT_TYPE_20_REFUND)
                            {
                                total_amount_paid += payment.amount ? payment.amount : 0;
                                total_due_amount += payment.due_amount ? payment.due_amount : 0;
                                late_payment_amount += payment.late_payment ? payment.late_payment : 0;
                                interest_paid_amount += payment.interest_paid_amount ? payment.interest_paid_amount : 0;
                            }
                        });

                        let outstanding_amount = total_due_amount - total_amount_paid;

                        sale["total_amount_paid"] = total_amount_paid;
                        sale["outstanding_amount"] = outstanding_amount;
                        sale["late_payment"] = late_payment_amount;
                        sale["interest_paid_amount"] = interest_paid_amount;
                    }
                    catch(ex){
                        console.log(ex);
                    }
                }
            });

            self.getStatus(show_loading);
            self.getProperty(show_loading);

            self.getReissuedSales(show_loading);

            // WEB-4686: the old timed full-list auto refresh (disabled) is replaced
            // by the sales change feed — see applySaleChanges().
        });
    }

    /**
     * Apply one answer of the sales change feed to the listing.
     *
     * @param {Object} data  `sec/developer/sales/changes` response data.
     * @returns {void}
     * @remarks WEB-4686. This page's rows are finished asynchronously (payment
     *          clauses, re-issue counts, status labels), so instead of patching rows the
     *          current page is silently re-fetched — page, filters and search kept —
     *          when a sale on it changed, a sale that may now belong on it changed, or
     *          the server asked for a full reload. A change already shown (the server's
     *          15 s overlap re-read) is ignored. If a popup is open for a sale another
     *          user just changed, it is closed and the user told who changed it, so no
     *          action runs on stale data.
     */
    applySaleChanges(data) {
        const self = this;

        if (data.full_reload_required) {
            self.retrieveApplications(self.current, false);
            return;
        }

        if (!(data.changes && data.changes.length)) {
            return;
        }

        const status_filter = self.getStatusFilter().map(Number);
        const open_sale = self.SSSaleChangeFeedService.findOpenPopupSale(self.getSalePopups());
        let reload = false;
        let open_sale_change = null;

        jQuery.each(data.changes, function (i, change) {
            const current = (self.sales || []).find(x => x.id == change.sale_id);

            if (!current) {
                if (change.listed && status_filter.indexOf(Number(change.status)) !== -1) {
                    reload = true;
                }
                return;
            }

            if (!self.SSSaleChangeFeedService.isNewerThanRow(change, current)) {
                return;
            }

            reload = true;

            if (open_sale && open_sale.id == change.sale_id
                && self.SSSaleChangeFeedService.isByAnotherUser(change)) {
                open_sale_change = change;
            }
        });

        if (open_sale_change) {
            self.hideModals();
            if ($('#ExecuteExerciseModal').is(':visible')) $('#ExecuteExerciseModal').modal('hide');
            if ($('#ExecuteExtendModal').is(':visible')) $('#ExecuteExtendModal').modal('hide');
            if ($('#returnSalesRemarksModal').is(':visible')) $('#returnSalesRemarksModal').modal('hide');
            self.SSAlertService.warning(
                'Sale updated',
                'This sale was updated by '
                    + self.SSSaleChangeFeedService.describeChange(open_sale_change)
                    + '. The list has been refreshed — please review the sale before continuing.'
            );
        }

        if (reload) {
            self.retrieveApplications(self.current, false);
        }
    }

    /**
     * Popups of this page that act on one sale, with the sale each one acts on.
     *
     * @returns {Array<{id: string, sale: Function}>}
     */
    getSalePopups() {
        const self = this;

        return [
            {id: '#developerSaleApplicationAcceptModal', sale: () => self.selected_sale},
            {id: '#developerSaleApplicationRejectModal', sale: () => self.selected_sale},
            {id: '#developerSaleApplicationOTPModal', sale: () => self.selected_sale},
            {id: '#returnSalesRemarksModal', sale: () => self.sale},
            {id: '#ExecuteExerciseModal', sale: () => self.sale},
            {id: '#ExecuteExtendModal', sale: () => self.sale},
            {id: '#ReIssueModal', sale: () => self.reissue_sale},
            {id: '#abortSaleModal', sale: () => self.abort_sale},
            {id: '#rollbackAbortSaleModal', sale: () => self.rollback_abort_sale},
            {id: '#cancelReissueModal', sale: () => self.reissued_sale}
        ];
    }


    getExpiryDate(spaDate){
        var spa_date = spaDate.split(' ');
        var strDate = spa_date[0].split('-');
        var nrAddDays = 21;
        var date = new Date(parseInt(strDate[0]), parseInt(strDate[1]) - 1, parseInt(strDate[2]));
        date.setDate(date.getDate() + nrAddDays);
        var actual_expiry_date = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
        return actual_expiry_date;
    }

    ExecuteExerciseModal(sale) {
        const self = this;
        self.hideModals();
        self.sale = sale;
        // self.selected_broker = broker;
        self.$timeout(function() { $('.datepicker').datepicker({changeMonth: true, changeYear: true, dateFormat: 'dd/mm/yy' }); });
        $('#ExecuteExerciseModal').modal('show');
    }

    ExecuteExtendModal(sale) {
        const self = this;
        self.hideModals();

        self.sale = sale;
        self.extendedExpiryDate = self.SSDateService.dateFormat3(sale.expiry_date);

        self.$timeout(function () {
            $('.datepicker').datepicker({changeMonth: true, changeYear: true, dateFormat: 'dd/mm/yy'});
        });
        $('#ExecuteExtendModal').modal('show');
    }

    showBuyersModal(sale, beneficiaries) {
        const self = this;
        self.hideModals();

        self.showBuyer = true;
        self.selected_buyers = sale.buyers || null;
        self.selected_beneficiaries = sale.beneficiaries || null;
        $('#developerSaleApplicationBuyerModal').modal('show');
    }

    reissuedForBuyerSigning(sale){
        const self = this;

        if(sale.last_reissued_from_sale && sale.last_reissued_from_sale.reissued_code == self.SALE_STATUS_PENDING){
            return true;
        }
        else{
            return false;
        }
    }

    proceedForBuyerSigningWithNormalDocument(sale) {
        const self = this;

        self.send_email_sale = sale;

        self.OTPService.getVerified(
            self.OTPService.TYPE_SESSION_2FA,
            function(data){
                self._proceedForBuyerSigningWithNormalDocument();
        });
    }

    _proceedForBuyerSigningWithNormalDocument() {
        const self = this;

        let url = 'sec/developer/sales/'+ self.send_email_sale.id +'/send-for-resigning';

        loading(true);
        self.SSHttpService.postAPIRequest(url).then(function (response) {
            loading(false);
            self.hideModals();
            if (response instanceof Error) {
                if (response.sub_code == 305015 || response.sub_code == 412002) {
                    self.SSAlertService.danger("Please Note:", "This sale has been updated by another user. You will not be able to make further updates to this sale.")
                    return;
                }
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.send_email_sale.reissue_steps_status = 2;

            self.SSConfirmationService.getConfirmed(
                'Success!',
                'The documents have been successfully sent to the respective buyers for their signature',
                self.SSConfirmationService.TYPE_OK,
                function() {

                }
            );
        });
    }

    // New functions for 'Additional Re-issue' case
    proceedForBuyerSigning(sale){
        const self = this;

        self.sale_id = sale.id;

        self.SSConfirmationService.getConfirmed(
            'Confirm!',
            'Are you sure you would like to send emails for resigning?',
            self.SSConfirmationService.TYPE_OK_CANCEL,
            function() {
                self.OTPService.getVerified(
                    self.OTPService.TYPE_SESSION_2FA,
                    function(data){
                        self._proceedForBuyerSigning();
                });
            }
        );
    }

    _proceedForBuyerSigning(){
        const self = this;

        let url = 'sec/sales/'+ self.sale_id +'/documents/send-signing-emails';
        let params = {
            mode: 'email'
        };

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                if (response.sub_code == 305015 || response.sub_code == 412002) {
                    self.SSAlertService.danger("Please Note:", "This sale has been updated by another user. You will not be able to make further updates to this sale.")
                    return;
                }
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.SSAlertService.success('Success!', 'Emails sent successfully.');
        });
    }

    cancelReissue(sale){
        const self = this;

        self.OTPService.getVerified(
            self.OTPService.TYPE_SESSION_2FA,
            function(data){

            self.reissued_sale = sale;
            self.cancel_reissue_remarks = '';
            $('#cancelReissueModal').modal('show');
        });
    }

    _cancelReissue(){
        const self = this;

        let sale = self.reissued_sale;

        let url = 'sec/developer/sales/' + sale.id + '/reissue-cancel';
        let params = {
            remarks: self.cancel_reissue_remarks
        };

        loading(true);
        self.SSHttpService.putAPIRequest(url, params).then(function (response) {
            loading(false);
            self.hideModals();

            if (response instanceof Error) {
                if (response.sub_code == 305015 || response.sub_code == 412002) {
                    self.SSAlertService.danger("Please Note:", "This sale has been updated by another user. You will not be able to make further updates to this sale.")
                    return;
                }
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.SSAlertService.success('Success!', 'Re-issue cancelled successfully.');

            self.retrieveApplications();
        });
    }

    hideModals() {
        const self = this;

        self.showReview = false;
        self.showAccept = false;
        self.showReject = false;
        self.showAgent = false;
        self.showBuyer = false;
        self.showOTPModal = false;
        self.showAddRemarks = false;

        if ($('#developerSaleApplicationReviewModal').is(':visible')) $('#developerSaleApplicationReviewModal').modal('hide');
        if ($('#developerSaleApplicationAcceptModal').is(':visible')) $('#developerSaleApplicationAcceptModal').modal('hide');
        if ($('#developerSaleApplicationRejectModal').is(':visible')) $('#developerSaleApplicationRejectModal').modal('hide');
        if ($('#developerSaleApplicationAgentModal').is(':visible')) $('#developerSaleApplicationAgentModal').modal('hide');
        if ($('#developerSaleApplicationBuyerModal').is(':visible')) $('#developerSaleApplicationBuyerModal').modal('hide');
        if ($('#developerSaleApplicationOTPModal').is(':visible')) $('#developerSaleApplicationOTPModal').modal('hide');
        if ($('#addSaleRemarksModal').is(':visible')) $('#addSaleRemarksModal').modal('hide');
        if ($('#developerSaleApplicationExportModal').is(':visible')) $('#developerSaleApplicationExportModal').modal('hide');
        if ($('#ReIssueModal').is(':visible')) $('#ReIssueModal').modal('hide');
        if ($('#abortSaleModal').is(':visible')) $('#abortSaleModal').modal('hide');
        if ($('#cancelReissueModal').is(':visible')) $('#cancelReissueModal').modal('hide');
        if ($('#rollbackAbortSaleModal').is(':visible')) $('#rollbackAbortSaleModal').modal('hide');
        if ($('#developerSalePaymentInvoicesModal').is(':visible')) $('#developerSalePaymentInvoicesModal').modal('hide');
        if ($('#developerSalePaymentReceiptsModal').is(':visible')) $('#developerSalePaymentReceiptsModal').modal('hide');

        //if ($('#ExecuteSPAModal').is(':visible')) $('#ExecuteSPAModal').modal('hide');

    }

    getPaymentClauses(sale, clause_id) {
        const self = this;

        let url = 'sec/developer/payment-plans/' + sale.payment_plan_id + '/clauses';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if (response.data.payment_plan_clauses && response.data.payment_plan_clauses.length > 0) {
                let new_payment_obj = {
                    id: sale.payment_plan_id,
                    clauses: response.data.payment_plan_clauses
                };

                self.payment_plans.push(new_payment_obj);

                sale["current_clause"] = self.getPaymentClauseName(response.data.payment_plan_clauses, clause_id);
            }
        });
    }

    getPaymentClauseName(clauses, clause_id) {
        const self = this;

        let payment_clause = clauses.find(x => x.id == clause_id);

        if (payment_clause) {
            return payment_clause.name;
        } else {
            return "--";
        }
    }

    getMarketingSchemeName(marketingScheme){
        const self = this;
        if(!marketingScheme) return;
        let name = self.SSConfigService.searchArray("marketing_schemes", marketingScheme);
        if(name) {
            name = "(" + name + ")";
        }
        return name;
    }

    clearSelectize(id){
        const self = this;

        if(!id){
            return;
        }

        try{
            let selectize = $("#" + id)[0].selectize;

            if(selectize){
                selectize.destroy();
            }
        }
        catch(ex){
            console.log(ex);
        }
    }

    resetPaymentTypeDropDown(){
        const self = this;
        self.payment_type = "";
        self.clearSelectize('payment_type_multiple');
        var _payment_types = self.payment_types;
        self.$timeout(function(){
            var $select = $('#payment_type_multiple').selectize({
                valueField: 'id',
                labelField: 'name',
                sortDirection: 'desc',
                maxItems: null,
                options: _payment_types,
                items: null
            });
            }, 0);
    }

    /** WEB-3053 DMS - Sales & Payments - Buyer Info update - START **/
    getCompanyIndex(buyer, buyer_list) {
      const self = this;

      if (!buyer || ! buyer_list) { return 0; } // If params missing return 0 by default

      let companies = buyer_list.filter(b => b.type === self.BUYER_TYPE_COMPANY); // Filter all companies from buyer_list
      if (companies && companies.length) { // If companies found in buyer_list
          return companies.findIndex(c => c.id === buyer.id) + 1; // Get company index in companies
      }
      return 1; // Fallback
    }

    getSignatoryIndex(buyer, buyer_list) {
        const self = this;

        if (!buyer || ! buyer_list) { return 0; } // If params missing return 0 by default
        let companySignatories = buyer_list.filter(b => b.buyer_company_id && b.buyer_company_id === buyer.buyer_company_id); // Filter all signatories of buyer company
        if (companySignatories && companySignatories.length) { // If company signatories found in buyer_list
            return companySignatories.findIndex(cs => cs.id === buyer.id) + 1; // Get signatory index in list of company signatories
        }
        return 1; // Fallback
    }

    getSignatoryCompanyIndex(buyer, buyer_list) {
        const self = this;

        if (!buyer || ! buyer_list) { return 0; } // If params missing return 0 by default
        let signatoryCompany = buyer_list.find(b => b.id === buyer.buyer_company_id); // Find signatory company in buyer_list
        if (signatoryCompany) { // If signatory company found in buyer_list
            return self.getCompanyIndex(signatoryCompany, buyer_list); // Get company index
        }
        return 1; // Fallback
    }
    /** WEB-3053 DMS - Sales & Payments - Buyer Info update - END **/

    savePropertyIdLocalStorage(){
        const self = this;
        self.SSUtilService.saveToLocalStorage("lastPropertyId", self.property_id);
    }
}

PaymentApplicationController.$inject = [
    '$scope',
    '$window',
    '$filter',
    'SSUserService',
    'SSAppService',
    'SSHttpService',
    'SSUtilService',
    'SSEoiService',
    'SSDateService',
    'SSAlertService',
    'OTPService',
    'SSConfirmationService',
    '$timeout',
    'SSConfigService',
    'NgTableParams',
    'SSAnalyticsService',
    'SSSaleRemarksService',
    'SSLmsDmsUtilService',
    'SSSaleChangeFeedService'
];
app.controller('PaymentApplicationController', PaymentApplicationController);

// WEB-4414: `datepicker` is registered once, globally, by services/key_handover.js (services.js is
// loaded on every page). A copy here would link it a second time on every element.


app.directive('dateformat', function (dateFilter) {
    return {
        require:'ngModel',
        link:function (scope, elm, attrs, ctrl) {

            var dateFormat = attrs['date'] || 'dd/MM/yyyy';

            ctrl.$formatters.unshift(function (modelValue) {
                return dateFilter(modelValue, dateFormat);
            });
        }
    };
})